import { customPalette } from 'theme/layer00';

export const typography = {
  fontFamily: [
    'Roboto',
    'Lexend'
  ].join(','),
  h1: {
    fontFamily: 'Lexend',
    fontSize: '2rem',
    fontWeight: '600',
    lineHeight: '2rem' /* 100% */,
    letterSpacing: '0.025rem',
    textTransform: 'none'
  },

  h2: {
    fontFamily: 'Lexend',
    fontSize: '1.5rem',
    fontWeight: '600',
    lineHeight: '1.5rem',
    letterSpacing: '0.025rem'
  },
  h3: {
    fontFamily: 'Lexend',
    fontSize: '2rem',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem'
  },
  h4: {
    fontFamily: 'Lexend',
    fontSize: ' 1.25rem',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem',
    textTransform: 'none'
  },
  h4Heavy: {
    fontFamily: 'Lexend',
    fontSize: ' 1rem',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem',
    textTransform: 'none'
  },
  h5: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '0.0625rem'
  },
  h6: {
    fontFamily: 'Lexend',
    fontSize: '1.1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.025rem'
  },
  body1: {
    color: '#474E4B',
    fontFamily: 'Lexend',
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: '0.8125rem',
    letterSpacing: '0.01625rem'
  },
  activityHeader: {
    color: `${customPalette.primaryColor.darker200}`,
    fontFamily: 'Lexend',
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '1.375rem',
    letterSpacing: '-.03rem',
    textTransform: 'none'
  },
  navItemText: {
    fontFamily: 'Lexend',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal'
  },
  navItemSubheader: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: '0.0125rem'
  },
  button: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: 'normal',
    textTransform: 'none'
  },
  body2: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '0.025rem',
    color: customPalette.primaryColor.darker140
  },
  formLabel: {
    color: customPalette.gray.light80,
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '1.5rem',
    textTransform: 'none'
  },
  activitySubHeaderPrimary: {
    color: customPalette.gray.light60,
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '1.25rem',
    letterSpacing: '0.015rem',
    textTransform: 'none'
  },
  tableTitle: {
    color: `${customPalette.primaryColor.darker200}`,
    fontFamily: 'Lexend',
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '3rem',
    letterSpacing: '-.03rem',
    textTransform: 'none'
  },
  tableHeader: {
    fontFamily: 'Lexend',
    fontSize: '12px',
    color: '#474E4B',
    textTransform: 'uppercase'
  },
  rowLabel: {
    color: customPalette.gray.light80,
    fontFamily: 'Lexend',
    fontSize: '.625rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    textTransform: 'uppercase'
  },

  tableCellLink: {
    color: customPalette.primaryColor.dark,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: '.025rem'
  },
  tabSectionHeader: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.02rem',
    textTransform: 'none'
  },
  tabSectionSubheader: {
    fontFamily: 'Roboto',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'uppercase',
    color: customPalette.gray.light80
  },
  tabSectionTextRegular: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    letterSpacing: '0.01375rem',
    textTransform: 'capitalize'
  },
  loginFormTitle: {
    fontFamily: 'Lexend',
    fontSize: '2rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '140%',
    letterSpacing: '-0.08rem',
    textTransform: 'none',
    color: customPalette.primaryColor.darker200
  },
  tabSectionTextBold: {
    fontFamily: 'Roboto',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'none'
  },
  tabSectionTextLink: {
    fontFamily: 'Roboto',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'uppercase',
    color: customPalette.primaryColor.dark
  },
  dropDownMenuItem: {
    fontFamily: 'Roboto',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '140%',
    letterSpacing: '0.0175rem',
    textTransform: 'none'
  },
  dropDownMenuTitle: {
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
    textTransform: 'none'
  },
  modalSummaryPaneTitle: {
    fontFamily: 'Roboto',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '1rem',
    textTransform: 'none'
  },
  modalSummaryPaneStepTitle: {
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontStyle: 'normal',
    lineHeight: '1rem',
    textTransform: 'none',
    color: customPalette.primaryColor.dark
  },
  modalSummaryPaneStepSubheader: {
    fontFamily: 'Source Sans Pro',
    fontSize: '.75rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '1rem',
    textTransform: 'none',
    letterSpacing: '.015rem',
    color: '#A0A0A1'
  },
  toolTip: {
    fontFamily: 'Lexend',
    fontSize: '.875rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    textTransform: 'none',
    letterSpacing: '.015rem',
    color: customPalette.primaryColor.darker200
  },
  chartTitle: {
    fontFamily: 'Lexend',
    fontSize: '1.1rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    letterSpacing: '-0.05625rem',
    color: customPalette.gray.light80
  },
  dataSummaryCardTitle: {
    fontFamily: 'Lexend',
    fontSize: '.9375rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    letterSpacing: '-0.05625rem',
    color: customPalette.gray.light80
  },
  dataSummaryCardSubTitle: {
    fontFamily: 'Lexend',
    fontSize: '.75rem',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '.75rem',
    textTransform: 'none',
    letterSpacing: '0.015rem',
    color: customPalette.gray.light20
  },
  summaryMetricName: {
    fontFamily: 'Lexend',
    fontSize: '.65rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    textTransform: 'uppercase',
    color: '#fff'
  },
  summaryMetricValue: {
    fontFamily: 'Lexend',
    fontSize: '2.5rem',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '2.5rem',
    textTransform: 'uppercase',
    letterSpacing: '-.05rem',
    color: '#fff'
  },

  chatInput: {
    fontFamily: 'Roboto',
    fontSize: '.75rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    textTransform: 'none',
    color: customPalette.primaryColor.light05
  },
  chatMessageTitle: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    textTransform: 'none',
    color: customPalette.primaryColor.light60
  },
  chatMessageBody: {
    fontFamily: 'Lexend',
    fontSize: '1.3rem',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: 'normal',
    textTransform: 'none',
    color: '#FFF'
  },

  styleTextChip: {
    fontFamily: 'Roboto',
    fontSize: '.85rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '140%',
    textTransform: 'none'
  },
  loginSectionTitle: {
    fontFamily: 'Lexend',
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '140%',
    letterSpacing: '0.02rem',
    textTransform: 'none'
  },
  loginSectionSubTitle: {
    fontFamily: 'Lexend',
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '140%',
    color: customPalette.gray.light60,
    textTransform: 'none'
  }
} as const;
